/**
 * @generated SignedSource<<3b9b12dd28950691a54f5384a4d5df0c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { Semver } from "@/common/relayCustomScalar";
export type UpdateWorkspaceVersionInput = {
  libNotebook?: string | null | undefined;
  overviewNotebook?: string | null | undefined;
  version?: Semver | null | undefined;
};
export type WorkspaceVersionRenameButtonMutation$variables = {
  id: string;
  input: UpdateWorkspaceVersionInput;
};
export type WorkspaceVersionRenameButtonMutation$data = {
  readonly updateWorkspaceVersion: {
    readonly id: string;
    readonly version: Semver;
  };
};
export type WorkspaceVersionRenameButtonMutation = {
  response: WorkspaceVersionRenameButtonMutation$data;
  variables: WorkspaceVersionRenameButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "WorkspaceVersion",
    "kind": "LinkedField",
    "name": "updateWorkspaceVersion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceVersionRenameButtonMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "WorkspaceVersionRenameButtonMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "41f285d8b760a32e548a62ce53f913f0",
    "id": null,
    "metadata": {},
    "name": "WorkspaceVersionRenameButtonMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceVersionRenameButtonMutation(\n  $id: ID!\n  $input: UpdateWorkspaceVersionInput!\n) {\n  updateWorkspaceVersion(id: $id, input: $input) {\n    id\n    version\n  }\n}\n"
  }
};
})();

(node as any).hash = "b7ccc340425ae9218b220e75a652de5a";

export default node;
